import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	activityTable: {
		flex: '0 0 600px',
		width: 600,
	},
	body: {
		alignItems: 'flex-start',
		boxSizing: 'border-box',
		display: 'flex',
		gap: SPACE[32],
		width: '100%',
	},
	container: {},
	prizePanel: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: SPACE[12],
		minWidth: 0,
	},
	prizeTableTitle: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
});
